module.exports = "/_next/static/images/wm-af1e27945c2bcc3ccbe8412ec164a6b3.png";